import { Button, DatePicker, Form, FormInstance, FormProps, Input, Modal, Select, SelectProps, Tabs, Tooltip } from 'antd';
import { useForm, useWatch } from 'antd/lib/form/Form';
import { SearchProps } from 'antd/lib/input';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'react-lottie';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../../Layout';
import * as VoucherApi from '../../api/voucher/voucherApi';
import SearchLoading from '../../assets/json/search-loading.json';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import VoucherResultCard from '../../components/Cards/VoucherResultCard';
import useToast from '../../hook/useToast';
import { selectorUnitByUserPermission } from '../../store/slices/UnitByUserPermission';
import { selectorCategoryCarIds } from '../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { createGroupedSelectOptionsV2, fommatSelectOption, fommatSelectOptionUnitByUser, fommatSelectOptionV2, getTitleSelectOption, getUserPermissions } from '../../until';
import './VoucherSearch.scss';
import useLoading from '../../hook/useLoading';
import { getSlContractsAndInvoices } from '../../api/selectOptions/selectOptionsApi';
import useDebounce from '../../hook/useDebounce';
import { ISearchCardCustomer, searchCardCustomer } from '../../api/rank/rankApi';
import OverViewCardCustomer from '../../components/Cards/OverViewCardCustomer';
import CustomerResultCard from '../../components/Cards/CustomerResultCard';
import { selectorPermission } from '../../store/slices/permissionSlice';

const { Search } = Input;

enum TYPESEARCH {
  VOUCHER = '1',
  CARD_ISSUANCE = '2'
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: SearchLoading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const VoucherSearch: React.FC = () => {


  const location = useLocation()

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, download } = getUserPermissions
  (permissionSlice, location.pathname)

  const pushToast = useToast();
  const pushLoading = useLoading()

  const [form] = useForm();
  const formRef = useRef<FormInstance>(null);
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

  const { unitTemp, } = useSelector(selectorInfoUser) // đợn vị dc chọn


  const date = useWatch('date', form)
  const customerValue = Form.useWatch("customer", form);


  const [isModalShow, setModalShow] = useState(false)
  const [isEmpty] = useState(true)
  const [isSearching, setSearching] = useState(false)
  const [isSearched, setSearched] = useState(false)
  const [valueSearch, setValueSearch] = useState<string>('')

  const [valueTab, setValueTab] = useState<TYPESEARCH>(TYPESEARCH.VOUCHER)
  const [invoicesByCustomer, setInvoicesByCustomer] = useState<SelectProps["options"]>();

  const [dataLoopupVoucher, setDataLoopupVoucher] = useState<VoucherApi.ILoopupVoucher>()
  const [dataCardCustomer, setDataCardCustomer] = useState<ISearchCardCustomer>()

  const start = dayjs(
    `${dataLoopupVoucher?.actualStartTime} ${dataLoopupVoucher?.timeStart}`,
    "DD/MM/YYYY HH:mm"
  );

  const end = dayjs(
    `${dataLoopupVoucher?.dateEnd} ${dataLoopupVoucher?.timeEnd}`,
    "DD/MM/YYYY HH:mm"
  );

  const onChangeTabs = (values: any) => {
    setValueTab(values)
  }

  const getSearchCardCustomer = async (code: string) => {
    const result = await searchCardCustomer(code);
    if (result.status) {
      setDataCardCustomer(result.data)
    } else {
      setSearched(false)
      setSearching(false)
      setDataCardCustomer(undefined)
      pushToast(result.message, "error", 2000)

    }
  }


  const getLoopupVoucher = async (code: string) => {
    const result = await VoucherApi.getLoopupVoucher(code);
    if (result.status) {
      setDataLoopupVoucher(result.data)
    } else {
      setSearched(false)
      setSearching(false)
      setDataLoopupVoucher(undefined)
      pushToast(result.message, "error", 2000)

    }
  }

  // const getInfoVoucher = async (id: number) => {
  //   const result = await VoucherApi.getInfoVoucher(id);
  //   if (result.status) {
  //     setDataVoucherDetail(result.data)

  //   } else {
  //     pushToast(result.message, "error", 2000)

  //   }
  // }

  const fetchSlContractsAndInvoices = useDebounce(async (idCustomer: number, search?: string) => {
    if (!idCustomer) return;
    pushLoading(true);
    try {
      const result = await getSlContractsAndInvoices(idCustomer, search);
      if (result?.status) {
        const options = createGroupedSelectOptionsV2(result.data);
        setInvoicesByCustomer(options);
      }
    } catch (e) {
      console.error(e);
    } finally {
      pushLoading(false);
    }
  }, 300)


  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    switch (valueTab) {
      case TYPESEARCH.VOUCHER:

        getLoopupVoucher(value)

        break;
      case TYPESEARCH.CARD_ISSUANCE:
        getSearchCardCustomer(value)
        break;
    }
    setValueSearch(value)
    setSearching(true)
    setTimeout(() => {
      setSearching(false)
      setSearched(true)
    }, 1000)
  }

  const onSubmitForm = () => {
    if (formRef.current) {
      formRef.current.submit()
    }
  }

  const onFinish: FormProps["onFinish"] = async (values) => {

    // const ids = Array.from(selectedIds).map(id => Number(id));
    const [invoiceCode, type] = values.invoiceNumber.split("-%-")
    if (!dataLoopupVoucher) return
    const convertedData = {
      customerId: Number(dataLoopupVoucher.customerId),
      voucherCodeId: Number(dataLoopupVoucher.id),
      invoiceCode,
      type,
    };


    // console.log(date)
    const dateTmp = date.format("YYYY/MM/DD")
    const result = await VoucherApi.conversionVoucher([convertedData], unitTemp, dateTmp)


    if (result?.status) {
      setModalShow(false)
      getLoopupVoucher(valueSearch)
      pushToast(result?.message, "success")
    } else {
      pushToast(result?.message, "warning")
    }

  };

  useEffect(() => {
    if (isModalShow) {
      fetchSlContractsAndInvoices(Number(dataLoopupVoucher?.customerId))

    } else {
      form.resetFields();
    }
  }, [isModalShow])
  return (
    <Layout
      contentClassName="voucher-search-content"
    >
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Marketing', },
          { title: 'Tra cứu voucher và thẻ thành viên', },
        ]}
        title='Tra cứu voucher và thẻ thành viên'
      />
      <Tabs
        className="detail-rank-tabs"
        defaultValue={valueTab}
        onChange={onChangeTabs}
        items={[
          {
            key: '1',
            label: `Voucher`,
            children: <div className="voucher-search-block">
              <div className="title">Tra cứu</div>
              <Search
                placeholder="Tra cứu Voucher"
                allowClear
                onSearch={onSearch}
              />

              {
                (isEmpty && !dataLoopupVoucher && !isSearching) &&
                <>
                  <img
                    src="/images/search-with-no-result.svg"
                    alt="no-result"
                    className="no-result-img"
                  />
                  <span>Nhập mã Voucher hoặc mã thẻ thành viên để tìm kiếm</span>
                </>
              }

              {
                isSearching &&
                <>
                  <div className="search-loading-img">
                    <Lottie
                      options={defaultOptions}
                    />
                  </div>
                  <span>Hệ thống đang tìm kiếm...</span>
                </>
              }

              {
                isSearched && dataLoopupVoucher &&
                <VoucherResultCard
                  dataLoopupVoucher={dataLoopupVoucher}
                  ctaClick={() => { setModalShow(true); }}
                  edit = {edit}
                />
              }
            </div>,
          },
          {
            key: '2',
            label: `Thẻ thành viên`,
            children: <div className="voucher-search-block">
              <div className="title">Tra cứu</div>
              <Search
                placeholder="Tra cứu thẻ thành viên"
                allowClear
                onSearch={onSearch}
              />

              {
                (isEmpty && !dataCardCustomer && !isSearching) &&
                <>
                  <img
                    src="/images/search-with-no-result.svg"
                    alt="no-result"
                    className="no-result-img"
                  />
                  <span>Nhập mã Voucher hoặc mã thẻ thành viên để tìm kiếm</span>
                </>
              }

              {
                isSearching &&
                <>
                  <div className="search-loading-img">
                    <Lottie
                      options={defaultOptions}
                    />
                  </div>
                  <span>Hệ thống đang tìm kiếm...</span>
                </>
              }

              {
                isSearched && dataCardCustomer &&
                <CustomerResultCard
                  dataCardCustomer={dataCardCustomer}
                // ctaClick={() => { setModalShow(true); }}
                />
              }
            </div>,
          },
        ]}
      />




      {/* Modal quy đổi */}
      <Modal
        title="Cập nhật Voucher thủ công"
        open={isModalShow}
        centered
        footer={[
          <span
            key="back"
            className="neutral-gray-400 cursor-pointer"
            onClick={() => setModalShow(false)}
          >Hủy</span>,
          <Button
            key="submit"
            type="primary"
            // loading={confirmLoading}
            onClick={onSubmitForm}
            className="rs-button"
          >
            Xác nhận đã quy đổi
          </Button>,
        ]}
        className="rs-modal w-400"
        onCancel={() => setModalShow(false)}
      >

        <Form
          form={form}
          ref={formRef}
          name="basic"
          autoComplete="off"
          className="rs-form voucher-update-form"
          onFinish={onFinish}
          initialValues={{
            unitId: getTitleSelectOption(fommatSelectOptionUnitByUser(unitByUserPermissionSlice), unitTemp),
            customer: `${dataLoopupVoucher?.customerName} (${dataLoopupVoucher?.customerCode})`
          }}

        >
          <Form.Item name="unitId" rules={[{ required: true, message: 'Vui lòng nhập đơn vị quy đổi!' }]}>
            {/* <Input disabled placeholder="Đơn vị quy đổi" className="custom-input-css custom-page-css border " /> */}
            <Select
              className="custom-page-css border rounded w-full"
              placeholder="Đơn vị quy đổi"
              showSearch
              allowClear
              filterOption={false}

              options={fommatSelectOptionV2(dataLoopupVoucher?.appliedUnitsList ?? [])}
            />
          </Form.Item>
          <Form.Item
            name="date"
            initialValue={dayjs()}
            rules={[{ required: true, message: 'Vui chọn ngày quy đổi!' }]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              placeholder="Ngày quy đổi"
              className="custom-input-date custom-page-css w-full"
              popupClassName="rs-date-picker-dropdown"
              disabledDate={(current) => {
                if (!current) return false;

                return (
                  current.isBefore(start, "day") ||
                  current.isAfter(end, "day")
                );
              }}
            />
          </Form.Item>

          <Form.Item name="customer">
            <Tooltip
              title={customerValue || ""}
              placement="topLeft"
            >
              <Input
                disabled
                placeholder={customerValue}
                className="custom-input-css custom-page-css border"
              />
            </Tooltip>
          </Form.Item>
          <div className="custom-page-css  w-full">
            <Form.Item
              name="invoiceNumber"
              noStyle
              rules={[{ required: true, message: 'Chọn hóa đơn!' }]}
            >
              <Select
                className="custom-page-css border rounded w-full"
                placeholder="Số hóa đơn"
                showSearch
                allowClear
                filterOption={false}
                onSearch={(value) => {
                  fetchSlContractsAndInvoices(Number(dataLoopupVoucher?.customerId), value);
                }}
                options={invoicesByCustomer || []}
              />
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </Layout >
  );
}

export default VoucherSearch;
